// DialogInvoiceAddress Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'

import Dialog from '../../../common/layout/dialog/dialog.jsx'
import Select from '../../../common/form/select/select.jsx'
import usastates from '../../../lib/usastates.jsx'
import IconButton from '../../../common/common/icon_button/icon_button.jsx'
import IntlMessage from '../../../common/common/intl/intl_message.jsx'
import Input from '../../../common/form/input/input.jsx'
import FabButtonManager from '../../../lib/fabbuttonmanager.jsx'

class DialogSubscriptionAddress extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false,
      street: '',
      postcode: '',
      city: '',
      state: '',
      dataDate: null
    }

    this._references = {
      refStreet: React.createRef(),
      refPostcode: React.createRef(),
      refState: React.createRef(),
      refCity: React.createRef()
    }
  }

  static get propTypes () {
    return {
      onSubmit: PropTypes.func,
      teamCountry: PropTypes.string
    }
  }

  static get defaultProps () {
    return {
      onSubmit: null,
      teamCountry: ''
    }
  }

  show (subscriptionObj) {
    FabButtonManager.setVisible(false)
    if (subscriptionObj) {
      this.setState({
        street: subscriptionObj.street ? subscriptionObj.street : '',
        postcode: subscriptionObj.postcode ? subscriptionObj.postcode : '',
        city: subscriptionObj.city ? subscriptionObj.city : '',
        state: subscriptionObj.state ? subscriptionObj.state : '',
        dataDate: new Date()
      })
    }
    this.setState({ active: true })
  }

  hide () {
    FabButtonManager.setVisible(true)
    this.setState({
      active: false,
      street: '',
      postcode: '',
      city: '',
      state: '',
      showError: false
    })
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = (ev) => {
    if (this.state.active && ev.keyCode === 13) {
      this._onFormSubmit(ev)
    }
  };

  showError () {
    this.setState({ showError: true })
  }

  render () {
    const classHeader = !this.state.showError
      ? 'dialogform-header'
      : 'dialogform-header showerr'

    return (
      <Dialog
        active={this.state.active}
        onClose={this.hide.bind(this)}
        type='medium'
        className='dialog-subscriptionaddress'
      >
        <div className='dialog-form subscriptionaddress-form'>
          <div className={classHeader}>
            {!this.state.showError ? (
              <div className='title'>
                <IntlMessage ident='setting.form.finalizeAddressTitle' />
                <span className='subtitle'>
                  <IntlMessage ident='setting.form.finalizeAddressSubTitle' />
                </span>
              </div>
            ) : (
              <div className='info'>
                <IntlMessage ident='setting.form.finalizeAddrErrorInfo' />
              </div>
            )}
            <IconButton
              icon='wizard-close'
              className='modal wizard-close dialog-form-close'
              canHover={false}
              onClick={this._onClickClose.bind(this)}
            />
          </div>
          <div className='dialogform-content'>
            <form
              className='form'
              method='post'
              noValidate
              action='#'
              onSubmit={this._onFormSubmit.bind(this)}
            >
              <div className='form-layout'>
                <div className='layoutcol'>
                  <div className='formsection'>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='street'
                          value={this.state.street}
                          label='setting.form.labelStreet'
                          ref={this._references.refStreet}
                          size={10}
                          maxLength={100}
                          validations={['required']}
                          onChange={this._onChangeInput.bind(this, 'street')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        {this.props.teamCountry === 'US' && (
                          <Select
                            options={usastates}
                            name='state'
                            label='setting.form.statePlaceholder'
                            className='form-dropdown'
                            ref={this._references.refState}
                            validations={['required']}
                            onChange={this._onChangeInput.bind(this, 'state')}
                            value={this.state.state}
                          />
                        )}
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='city'
                          value={this.state.city}
                          label='setting.form.labelCity'
                          ref={this._references.refCity}
                          size={10}
                          maxLength={100}
                          validations={['required']}
                          onChange={this._onChangeInput.bind(this, 'city')}
                        />
                      </div>
                    </div>
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='postcode'
                          value={this.state.postcode}
                          label='setting.form.labelZipCode'
                          ref={this._references.refPostcode}
                          size={10}
                          maxLength={100}
                          validations={['required']}
                          onChange={this._onChangeInput.bind(this, 'postcode')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <IconButton
              type='primary'
              size='big'
              icon='common-success-tick'
              title='setting.form.editSubscriptionSave'
              canHover={false}
              onClick={this._onFormSubmit.bind(this)}
            />
          </div>
        </div>
      </Dialog>
    )
  }

  /* Event Handlers */
  _onFormSubmit (_ev) {
    let noErrors = 0

    if (
      this._references.refStreet.current &&
      !this._references.refStreet.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refPostcode.current &&
      !this._references.refPostcode.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refState.current &&
      !this._references.refState.current.validate()
    ) {
      noErrors++
    } else if (
      this._references.refCity.current &&
      !this._references.refCity.current.validate()
    ) {
      noErrors++
    }

    if (noErrors === 0) {
      const updateObj = {
        street: this.state.street,
        postcode: this.state.postcode,
        city: this.state.city
      }

      if (this.props.teamCountry === 'US') {
        updateObj.state = this.state.state
      }

      if (this.props.onSubmit) {
        this.props.onSubmit(updateObj)
      }
    } else {
      this.setState({ showError: true })
    }
  }

  _onClickClose (ev) {
    ev.preventDefault()
    this.hide()
  }

  _onChangeInput (name, value) {
    const stateObj = {
      [name]: value
    }

    if (name === 'country' && value !== 'US') {
      stateObj.state = ''
    }

    this.setState(stateObj)
  }
}

export default DialogSubscriptionAddress
